/**
 * @file lib/wikifi.js
 * @description Thin API client for the Wikifi workspace routes.
 *
 * Every call carries the auth cookie via `withCredentials: true`. Never
 * touches the LLM key — that stays server-side. All persistence is behind
 * `/api/wikifi/conversations`; the actual LLM run is behind the existing
 * `/api/jobs/wikifi` async pattern.
 */
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cfg = { withCredentials: true };

export async function listModels() {
  const r = await axios.get(`${API}/wikifi/models`, cfg);
  return r.data;
}

export async function listConversations() {
  const r = await axios.get(`${API}/wikifi/conversations`, cfg);
  return r.data.items || [];
}

export async function getConversation(cid) {
  const r = await axios.get(`${API}/wikifi/conversations/${cid}`, cfg);
  return r.data;
}

export async function createConversation({ title, project } = {}) {
  const r = await axios.post(`${API}/wikifi/conversations`, { title, project }, cfg);
  return r.data;
}

export async function appendUserMessage(cid, text) {
  const r = await axios.post(`${API}/wikifi/conversations/${cid}/messages`, { text }, cfg);
  return r.data;
}

export async function renameConversation(cid, title) {
  const r = await axios.patch(`${API}/wikifi/conversations/${cid}`, { title }, cfg);
  return r.data;
}

export async function deleteConversation(cid) {
  const r = await axios.delete(`${API}/wikifi/conversations/${cid}`, cfg);
  return r.data;
}

// ── Workspace-adjacent endpoints ─────────────────────────────────────────
export async function getStarterTools(refresh = false) {
  const url = refresh
    ? `${API}/wikifi/starter-tools?refresh=1`
    : `${API}/wikifi/starter-tools`;
  const r = await axios.get(url, cfg);
  return r.data.items || [];
}

export async function getStack() {
  try {
    const r = await axios.get(`${API}/stack`, cfg);
    return r.data.stack || [];
  } catch (_) { return []; }
}

export async function getOrchestrator() {
  try {
    const r = await axios.get(`${API}/orchestrator`, cfg);
    return r.data;
  } catch (_) { return { slugs: [], tools: [], beta: true, integrated: [] }; }
}

export async function toggleOrchestrator(slug) {
  const r = await axios.post(`${API}/orchestrator/toggle`, { slug }, cfg);
  return r.data;
}
